// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_deleteDevelopmentProject(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["DevelopmentProjectDeleted"]);
}

let variablesConverter = {"deleteDevelopmentProjectInput":{},"__root":{"input":{"r":"deleteDevelopmentProjectInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"deleteDevelopmentProject":{"u":"response_deleteDevelopmentProject"}}};

let wrapResponseConverterMap = {
  response_deleteDevelopmentProject: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"deleteDevelopmentProject":{"u":"response_deleteDevelopmentProject"}}};

let responseConverterMap = {
  response_deleteDevelopmentProject: unwrap_response_deleteDevelopmentProject
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "developerNodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MyClientsWidgetDeleteDialog_mutations_deleteDevelopmentProjectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "deleteDevelopmentProject",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/)
            ],
            "type": "DevelopmentProjectDeleted",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MyClientsWidgetDeleteDialog_mutations_deleteDevelopmentProjectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "deleteDevelopmentProject",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "developerNodeId",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "type": "DevelopmentProjectDeleted",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f7058e2f6457d334fa955a7ab248befc",
    "id": null,
    "metadata": {},
    "name": "MyClientsWidgetDeleteDialog_mutations_deleteDevelopmentProjectMutation",
    "operationKind": "mutation",
    "text": "mutation MyClientsWidgetDeleteDialog_mutations_deleteDevelopmentProjectMutation(\n  $input: DeleteDevelopmentProjectInput!\n) {\n  deleteDevelopmentProject(input: $input) {\n    __typename\n    ... on DevelopmentProjectDeleted {\n      developerNodeId\n    }\n  }\n}\n"
  }
};
})());

let wrap_response_deleteDevelopmentProject = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_deleteDevelopmentProject = unwrap_response_deleteDevelopmentProject;
exports.wrap_response_deleteDevelopmentProject = wrap_response_deleteDevelopmentProject;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
